import React from 'react';
import { ProgressBar } from 'react-bootstrap';

import 'assets/scss/_progress.scss';
import useProgressState from 'global/progressState';
import comma from 'utils/format/comma';
import format from 'utils/string/format';

/**
 * 진행 표시 줄
 */
const Progress = () => {
  /* recoil */
  const { progress } = useProgressState();

  /* view */
  return (
    <>
      {progress.isShow && (
        <div className="progress-box">
          <ProgressBar
            animated
            label={format(progress.label, { now: comma(progress.now) })}
            now={progress.now}
            style={progress.style}
          />
        </div>
      )}
    </>
  );
};

export default Progress;
